import { API_ENCRYPT_SECRET_KEY } from "@lib/constants/AppConst";
import SimpleCrypto from "simple-crypto-js";

const crypto = new SimpleCrypto(API_ENCRYPT_SECRET_KEY);
export default crypto;
